/*       */
import React, { useState, useEffect, useCallback } from 'react';
import PageNotAllowed from 'app/containers/ErrorPages/PageNotAllowed';
// import { getLandingPageConfig } from 'app/config/tourConfig';
// import { openTour } from 'store/actions/app/appActions';
import {
    useSelector,
    //  useDispatch 
} from 'react-redux';
import { Divider } from '@mic3/platform-ui';
// import { Grid, Typography, Divider, Dialog, DialogTitle, DialogActions, DialogContent } from '@mic3/platform-ui';
// import { isMobile } from 'react-device-detect';
// import { saveUserPreferences } from 'store/actions/admin/usersActions';
import { useReactPWAInstall } from 'app/containers/Pwa/PwaIndex';

import styled from 'styled-components';

import LandingPageHeader from 'app/containers/LandingPage/Areas/LandingPageHeader';
// import AppTour from 'app/components/atoms/Tour/Tour';
// import Button from 'app/components/atoms/Designer/Button';
// import ComponentDefaultImage from 'assets/images/icons/checked.png';
import LandingPageWidgets from './Widgets/LandingPageWidgets';

const DividerStyled = styled(Divider)`
    margin: ${({ margin }) => (margin ? margin : '0px 16px 16px 16px')} !important;
`;
const GridWrapperStyled = styled.div`
    overflow-y: scroll !important;
`;

// const SubmitButton = styled(Button)`
//     background: linear-gradient(270deg, #5c3c98 0%, #3e55a5 52.49%, #198ad1 100%);
//     border-radius: 5rem !important;
// `;

// const StyledModalDialog = styled(Dialog)`
//     & .MuiPaper-root {
//         background: #fff !important;
//         color: black !important;
//     }
// `;

// const StyledGrid = styled(Grid)`
//     display: flex;
//     justify-content: center;
//     align-items: center;
// `;

const LandingPageBackgroundWrapper = styled.div`
    position: relative;
`;

const LandingPageBackground = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(/images/landing-page-background-new.png) 50% / cover no-repeat;
    background-size: cover;
    opacity: 20%;

`;

const LandingPage = (props) => {
    // const [showModal, setShowModal] = useState(false);
    const [widgetsKey, setWidgetsKey] = useState(0);
    const userProfile = useSelector((state) => state.user.profile);
    const pwaInstallCloseValue = localStorage.getItem(`pwaInstallClose_${userProfile?.id}`);
    const { permissions, isAdmin } = userProfile;
    const permissionsSet = new Set(permissions || []);
    const hasPermission = isAdmin || permissionsSet.has('abox.home');
    // const dispatch = useDispatch();
    // const landingPageConfig = getLandingPageConfig(dispatch);
    // const userPreferences = useSelector((state) => state.user.preferences);

    // const handleCloseAppTour = useCallback(() => {
    //     setShowModal(false);
    //     dispatch(saveUserPreferences({ tour: [...(userPreferences?.tour || []), 'landingpage'] }));
    // }, [userPreferences, dispatch]);

    // const handleStartAppTour = useCallback(() => {
    //     dispatch(openTour());
    //     setShowModal(false);
    // }, [dispatch]);

    const { pwaInstall, supported, isInstalled } = useReactPWAInstall();
    // const isTourFinish = userPreferences?.tour ? userPreferences?.tour.includes('landingpage') : null;
    useEffect(() => {
        if (!isInstalled() && supported() && !pwaInstallCloseValue
        // && isTourFinish
        ) {
            handleClick();
        }
    }, [isInstalled, supported, pwaInstallCloseValue]); //eslint-disable-line react-hooks/exhaustive-deps

    const handleClick = () => {
        pwaInstall({
            title: 'Add to homescreen',
        })
            .then(() => alert('App installed successfully or instructions for install shown'))
            .catch(() => alert('User opted out from installing'));
    };

    // useEffect(() => {
    //     if (!userPreferences?.tour?.includes('landingpage')) {
    //         setTimeout(() => {
    //             setShowModal(true);
    //         }, 2000);
    //     }
    // }, [userPreferences]);

    const handleReload = useCallback(() => {
        setWidgetsKey(widgetsKey + 1);
    }, [widgetsKey]);

    return (
        !hasPermission ?
            <PageNotAllowed title="homepage" hideBackMessage /> :
            <>
                <GridWrapperStyled>
                    <LandingPageBackgroundWrapper>
                        <LandingPageBackground />
                        <LandingPageHeader reload={handleReload} />
                    </LandingPageBackgroundWrapper>
                    <DividerStyled margin='0 8px' />
                    <LandingPageWidgets widgetsKey={widgetsKey} />
                </GridWrapperStyled>
                {/* {showModal && (
                <StyledModalDialog open>
                    <DialogTitle id='alert-dialog-title'></DialogTitle>
                    <DialogContent>
                        <Grid container spacing={4}>
                            {!isMobile && (
                                <StyledGrid item md={4} lg={3}>
                                    <img src={ComponentDefaultImage} alt='tutor' />
                                </StyledGrid>
                            )}
                            <Grid item xs={12} md={8} lg={9}>
                                <Typography variant='h4'>Welcome to A-Box</Typography>
                                <Typography variant='h6'>Take a Tour</Typography>
                                <DividerStyled />
                                <Typography variant='body1'>
                                    This module is all about collaboration and provides an integrated space for users and teams to
                                    communicate and work together on tasks, projects and entities.
                                </Typography>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DividerStyled />
                    <DialogActions>
                        <Button variant='text' onClick={handleCloseAppTour}>
                            {' '}
                            Skip Tutorial
                        </Button>
                        <SubmitButton onClick={handleStartAppTour}> SURE </SubmitButton>
                    </DialogActions>
                </StyledModalDialog>
            )} */}
                {/* <AppTour steps={landingPageConfig} pageName={'landingpage'} /> */}
            </>
    );
};

export default LandingPage;
